import { render, staticRenderFns } from "./UpcomingClasses.vue?vue&type=template&id=11119b4a&scoped=true"
import script from "./UpcomingClasses.vue?vue&type=script&lang=js"
export * from "./UpcomingClasses.vue?vue&type=script&lang=js"
import style0 from "./UpcomingClasses.vue?vue&type=style&index=0&id=11119b4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11119b4a",
  null
  
)

export default component.exports